import { type Participant, ParticipantState } from 'v2/types/call'

interface CanAddParticipantResult {
  canAdd: boolean
  disabledReason: string
}

export function getParticipantValidation({
  participants,
  hasOpenTasks,
}: {
  participants: Participant[]
  hasOpenTasks: boolean
}): CanAddParticipantResult {
  if (participants?.length >= 1)
    return { canAdd: false, disabledReason: 'Maximum participants limit reached' }

  if (participants.length > 0 && !participants.every((p) => p.state === ParticipantState.MERGED))
    return { canAdd: false, disabledReason: 'Cannot add participants in middle of transfer' }

  if (hasOpenTasks)
    return { canAdd: false, disabledReason: 'Cannot add participants while tasks are open' }

  return { canAdd: true, disabledReason: '' }
}
